<script>
  export let data = {
      elementID: '',
      title: ''
    },
    contact;

</script>

<b>"{data.title}"</b>